import './Logo.css';
import logoImage from '../../../logo/2/Sradha Technologies.png'; // Import the PNG version of your logo

const LogoSymbol = () => {
  return (
    <div className="logo">
      <img 
        src={logoImage} 
        alt="SradhaTech Logo" 
        className="logo-image"
      />
    </div>
  );
};

export default LogoSymbol;
